import React from 'react'
import ContentLoader from 'react-content-loader'

const CustomerTestimonial = props => {
  return (
    <ContentLoader
      width={1000}
      height={500}
      viewBox="0 0 400 160"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="80" y="73" rx="3" ry="3" width="254" height="6" />
      <rect x="78" y="88" rx="3" ry="3" width="254" height="6" />
      <rect x="150" y="103" rx="3" ry="3" width="118" height="6" />
      <circle cx="210" cy="27" r="22" />
    
      
      
    </ContentLoader>
  )
}

CustomerTestimonial.metadata = {
  name: 'Pranay Binju',
  github: 'pranaybinju',
  description: 'Customer Testimonial Skeleton',
  filename: 'CustomerTestimonial',
}

export default CustomerTestimonial